import { Spinner } from '@change/ds-core-ui';

import paypalLogo from 'src/assets/payment/paypal.png';

import { useSavedPaymentMethodButton } from '../../hooks/useSavedPaymentMethodButton';
import type { SavedPaymentMethodOption } from '../../shared/types';

type Props = {
	selectedPaymentMethod: SavedPaymentMethodOption | null;
};

export const PaypalButton: React.FC<Props> = ({ selectedPaymentMethod }) => {
	const {
		data: { loading },
		actions: { onClick },
	} = useSavedPaymentMethodButton();

	if (selectedPaymentMethod !== 'paypal') {
		return null;
	}
	return (
		<div className="w-full">
			<button
				type="submit"
				className="flex w-full cursor-pointer items-center justify-center rounded-lg py-3 transition-all hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-50"
				style={{ backgroundColor: '#FFD140' }}
				disabled={loading}
				data-qa="promote-saved-paypal-button"
				onClick={async () => onClick('paypal')}
			>
				{loading ? <Spinner className="size-6" /> : <img src={paypalLogo} alt="PayPal" className="h-6" />}
			</button>
		</div>
	);
};
